<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper">
    <div class="container-fluid" style="min-height: 0px;background-color: gray;">
        <div class="col-lg-12">
            <div class="row align-items-center">
                <div class="col-md mx-auto">
                    <div id="myCarousel" class="carousel slide carousel-container " data-ride="carousel"
                        data-interval="2500" style="text-align: center;width: auto;">
                        <!-- Indicators -->
                        <ol class="carousel-indicators">
                            <li *ngFor="let slide of data_slide; let i = index" [class.active]="i == 0"
                                style="background-color:#f89b82;" data-target="#myCarousel" [attr.data-slide-to]="i">
                            </li>
                        </ol>
                        <!-- Wrapper for slides -->
                        <div class="carousel-inner">
                            <div *ngFor="let slide of data_slide; let i = index" [class.active]="i == 0"
                                class="carousel-item">
                                <img [src]="slide.like_pic" [alt]="'Slide ' + slide.name" style="max-height:600px">
                                <!--<div class="carousel-caption">
                            <h3>{{ slide.name }}</h3>
                            <p>{{ slide.doc }}</p>
                            </div>-->
                            </div>
                        </div>
                        <!-- Left and right controls -->
                        <a class="carousel-control-prev" href="#myCarousel" role="button" data-slide="prev"
                            style="color: #414141;">
                            <span class="carousel-control-prev-icon" aria-hidden="true"
                                style="border : solid #f89b82;"></span>
                            <span class="sr-only">Previous</span>
                        </a>
                        <a class="carousel-control-next" href="#myCarousel" role="button" data-slide="next"
                            style="color: #414141;">
                            <span class="carousel-control-next-icon" aria-hidden="true"
                                style="border : solid #f89b82;"></span>
                            <span class="sr-only">Next</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <br>
        <div class="row justify-content-md-center">
            <div class="col-md-auto card" *ngIf="data_slide.length > 0">
                <div class="button-row">
                    <button mat-raised-button color="primary" (click)="Load_slide()">
                        <mat-icon> update </mat-icon></button>
                    &nbsp; &nbsp;
                    <span class="badge bg-warning">{{ data_slide.length }}</span> รายการ
                    &nbsp; &nbsp;
                    <button mat-raised-button (click)="update_t();" *ngIf="editer">
                        <mat-icon style="color: green;"> done </mat-icon>บันทึกแก้ไข
                    </button>
                </div>
                <!--<label> {{edit_st}} </label> *ngIf="dataApi1.length > 0 && edit_st == 0" -->
                <!--<a href={{data_insert.like_pic}} target="_blank">
                    -ไฟล์ที่อัพโหลด- <i class="fas fa-external-link-alt nav-icon"></i>
                </a>-->
            </div>

        </div>

        <div class="row justify-content-md-center">
            <div class="col-md-9 text-center">
                <div class="card">
                    <div class="table-responsive p-2" style="height: 600px">
                        <table class="table table-hover table-head-fixed table-bordered">
                            <thead>
                                <tr class="headText text-primary" style="text-align:center">
                                    <th>.</th>
                                    <th>id</th>
                                    <th>วันที่</th>
                                    <th>ชื่อ</th>
                                    <th>แสดง</th>
                                    <th>link_pic</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of data_slide_a ; let i = index;" style="text-align:center">
                                    <td>{{i+1}}</td>
                                    <td>{{item.id}}</td>
                                    <td>{{THtoLocalstring(item.date_add)}}</td>
                                    <td style="text-align:left">{{item.name}}</td>
                                    <td>
                                        <section class="example-section">
                                            <mat-radio-group [(ngModel)]="item.status"
                                                (ngModelChange)="item.modify = true;Change_val()">
                                                <mat-radio-button class="example-margin" value="1">
                                                    แสดง</mat-radio-button>
                                                <mat-radio-button class="example-margin" value="0">
                                                    ไม่แสดง</mat-radio-button>
                                            </mat-radio-group>
                                        </section>
                                    </td>
                                    <td>
                                        <a href="{{item.like_pic}}" target="_blank"
                                            class="badge badge-secondary">ดูรูป</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="row justify-content-md-center" *ngIf="editer">
                            <div class="col-md-auto text-center">
                                <div class="form-group">
                                    <label for="exampleFormControlFile1"> file for </label>
                                    <input mat-raised-button type="file" class="form-control-file"
                                        id="exampleFormControlFile1" type="file" accept="image/*"
                                        (change)="onFileSelected($event)">
                                    <a *ngIf="data_insert.like_pic" href={{data_insert.like_pic}} target="_blank">
                                        -ไฟล์ที่อัพโหลด- <i class="fas fa-file-download nav-icon"></i>
                                    </a>
                                </div>
                            </div>
                            <div class="col-md-auto text-center">
                                <mat-form-field class="example-full-width" appearance="fill">
                                    <mat-label>ชื่อเรื่อง</mat-label>
                                    <input matInput required placeholder="..ระบุหมายเหตุ..(ต้องมี)"
                                        [(ngModel)]="data_insert.name" maxlength="50" name="doc">
                                </mat-form-field>
                            </div>
                            <div class="col-md-auto text-center">
                                <div class="button-row">
                                    <button mat-raised-button color="primary" (click)="insert_to()"
                                        [disabled]="!data_insert.like_pic || !data_insert.name">
                                        เพิ่มข้อมูล
                                    </button>
                                </div>
                            </div>
                            <div class="text-center" *ngIf="isUploading">
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                <p>กำลังอัพโหลดไฟล์...</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>